import React, { useEffect, useState } from "react";
import Dashboard from "../layouts/Dashboard";
import { Card, Col, Row } from "antd";
import { Button } from "reactstrap";
import axios from "../services/axios";
import { message } from "antd";
import ReactLoading from "react-loading";
import { Pagination } from "antd";
import { AudioOutlined } from "@ant-design/icons";
import { Input, Space } from "antd";
import isConsultant from "../services/isConsultant";
const { Search } = Input;


const ViewDocuments = (props) => {

  const [status, setStatus] = useState("");

  useEffect(() => {
    loadLogs();
  }, []);

  const [current, setCurrent] = useState(1);

  const onChange = (page) => {
    console.log(page);
    setCurrent(page);
  };

  const onSearch = (value) => console.log(value);

  const loadLogs = () => {
    axios
      .get("OTPAutentication/OTPLogs", {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("user.token")}`,
        },
      })
      .then((res) => {
        console.log("logs", res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <div>
    {!isConsultant() && <Dashboard title="Documents">
      <div className="row p-3 border mb-2 bg-white cursor-pointer shadow-sm">
        
          <Search
            placeholder="input search text"
            onSearch={onSearch}
            style={{
              width: 200,
            }}
          />
        
      </div>

      <div className="card-body row p-3 border mb-2 bg-white cursor-pointer shadow-sm ">
        <table className="table bg-white ">
          <thead>
            <tr>
              <th>Emp Id</th>
              <th>Name</th>
              <th>Phone No</th>
              <th>Name</th>
              <th>Upload</th>
              <th>10th</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>21240201</td>
              <td>saini</td>
              <td>99844285211</td>
              <td>----</td>
              <td>jpg</td>
              <td>yes</td>
            </tr>
          </tbody>
        </table>
        <Pagination current={current} onChange={onChange} total={50} />
      </div>
    </Dashboard>}
    </div>
  );
};

export default ViewDocuments;
